import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OneTagResponse, TagsResponse, SubmitResponse, PaginatedTags } from '../../models';
import { TagInput } from '../../inputs/tag.input';
import { HttpService } from './http.service';
import { FilterInput } from '../../inputs';

@Injectable({
  providedIn: 'root'
})
export class TagService extends HttpService<
  // Inputs
  FilterInput | TagInput,
  // Responses
  PaginatedTags | TagsResponse | OneTagResponse
> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string,private http: HttpClient) {
    super(httpClient, apiUrl, apiVersion, 'tag');
  }

  // This is old (need to refactor)
  getAllTags(page = 1, limit?: number): Observable<TagsResponse> {
    return this.getAllPaged('admin', page, "",limit) as Observable<TagsResponse>;
  }

  getPage(page = 1): Observable<PaginatedTags> {
    return this.getAllPaged('admin', page) as Observable<PaginatedTags>;
  }

  findAllByName(text: string, page = 1): Observable<PaginatedTags> {
    const filter: FilterInput = {
      page: page,
      limit: 10,
      filters: {
        
            or: [
              ['$tag_translations.name$', 'ILIKE', `%${text}%`],
              ['slug', 'ILIKE', `%${text}%`]
            ]
          
      }
    };
    return this.filterAllActionPagedAdmin(filter,'admin') as Observable<PaginatedTags>;
  }

  getTagById(id: number): Observable<OneTagResponse> {
    return this.getById(id) as Observable<OneTagResponse>;
  }

  createTag(tag: TagInput): Observable<SubmitResponse> {
    return this.create(tag, 'admin');
  }

  updateTag(tag: TagInput): Observable<SubmitResponse> {
    return this.update(tag, 'admin');
  }

  deleteTag(tagId: number): Observable<SubmitResponse> {
    return this.delete('admin/'+tagId);
  }

  // Refactored

  getBySlugs(slugs: string[]): Observable<PaginatedTags> {
    const input: FilterInput = {
      page: 1,
      limit: slugs.length,
      filters: {
        and: [['slug', 'in', slugs]]
      }
    };
    return this.filterAllPaged(input) as Observable<PaginatedTags>;
  }

  updatedTagNewOptional(id: number, tag: TagInput): Observable<SubmitResponse> {
    return this.update(tag, 'admin', id);
}
}
